import { render } from "./promo-banner.vue?vue&type=template&id=b911ec66"
import script from "./promo-banner.vue?vue&type=script&lang=js"
export * from "./promo-banner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kevinschade/Code/bioeffect/New BIOEFFECt Wesbstie themes/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__